module.exports = __webpack_public_path__ + "static/media/invitation.9dfb35c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dialogduk/static/invitation.png
// module id = 161
// module chunks = 0